import { filterBy, isNotEmpty } from "neetocist";

const isTextMatching = (label, searchTerm) =>
  label.toLowerCase().includes(searchTerm.trim().toLowerCase());

export const scrollIntoSettingCategory = activeCategory => {
  document.getElementById(activeCategory)?.scrollIntoView({
    behavior: "smooth",
  });
};

export const filterCategories = ({ categories = [], searchTerm = "" }) => {
  const isSearchTermBlank = !searchTerm.trim();

  const filteredCategories = isSearchTermBlank
    ? categories
    : categories.map(category => ({
        ...category,
        items: filterBy(
          ({ label, description }) =>
            isTextMatching(label, searchTerm) ||
            isTextMatching(description, searchTerm),
          category.items
        ),
      }));

  return filterBy({ items: isNotEmpty }, filteredCategories);
};
